"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.messages = void 0;
/*eslint-disable*/const messages = {
  "Back to previous panel": "Назад к предыдущей панели",
  "Close Panel": "Закрыть панель",
  "Close {title}": ['Закрыть "', ["title"], '"'],
  "More options": "Дополнительные настройки",
  "Panel menu": "Меню панели"
};
exports.messages = messages;
//# sourceMappingURL=messages.js.map